import { ApiPatientContactResponseItem, PatientDetailsFormValues } from '../../models';

export class FetchPatientContacts {
  static readonly type = '[Patient Contacts] Fetch Patient Contacts';
}

export class UpdatePatientDetails {
  static readonly type = '[Patient Contacts] Update Patient Details';
  constructor(public patientDetailsFormValues: PatientDetailsFormValues) {}
}

export class SetPatientContacts {
  static readonly type = '[Patient Contacts] Set Patient Contacts';
  constructor(public apiContacts: ApiPatientContactResponseItem[]) {}
}
